import { Injectable } from '@angular/core';
import { BaseService } from '../../abstract/base.service';
import { DroneModel } from '../data-models/drone-model.model';

/**
 * Drone model lookups for dropdowns: `GET /lookups/drone-models` (hub `user-lookups-controller.ts`).
 * Read-only for web users; use the inherited `getMany()`.
 */
@Injectable({
  providedIn: 'root'
})
export class DroneModelService extends BaseService<DroneModel> {
  constructor() {
    super('lookups/drone-models', DroneModel);
  }
}
